import { Box, Typography, Grid } from "@mui/material";
import Paper from "@mui/material/Paper";
import Navbar from "../../../components/Navbar";
import { useEffect, useState, useCallback } from "react";
import FactoryStepper from "./components/FactoryStepper";
import FactoryOne from "./components/FactoryOne";
import FactoryTwo from "./components/FactoryTwo";
import FactoryThree from "./components/FactoryThree";
import FactoryFeatures from "./components/FactoryFeatures";
import FactoryExample from "./components/FactoryExample";
import FactoryPreview from "./components/FactoryPreview";
import { useApp } from "../../../hooks/useApp";
import { useLocation } from "react-router-dom";
import FactoryFour from "./components/FactoryFour";
import Gobutton from "../../../components/Gobutton";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const defaultAsset = {
  Title: "",
  Heading: "",
  AiFeatures: [],
  Features: [],
  Children: [],
  Image: "",
  desc: "",
  tulipLibrary: "",
  Type: "app",
  img: "",
  private: "",
  status: "review",
  dataTags: [],
  agents: [],
  dataSource: "",
};
const factorySteps = [
  "Choose Factory",
  "Define Factory",
  "Add Features",
  "Add Assets",
  "Add Ai Features",
  "Preview",
];
const megaFactorySteps = [
  "Choose Factory",
  "Add Factories",
  "Add Features",
  "Add Example",
  "Preview",
];
const editMegaFactorySteps = [
  "Edit Factory",
  "Edit Features",
  "Edit Example",
  "Preview",
];

const editFactorySteps = [
  "Edit Factory",
  "Edit Features",
  "Edit Assets",
  "Edit Ai Features",
  "Preview",
];

export default function FactoryForm() {
  const [asset, setAsset] = useState(null);
  const [activeStep, setActiveStep] = useState(0);

  const { combinedAssets } = useApp();
  const location = useLocation();

  // pull editableAsset from navigation state
  const { editableAsset } = location.state || {};
  const [steps, setSteps] = useState(
    editableAsset 
            ? (editableAsset.Type === 'factory' 
                        ? editFactorySteps 
                        : editMegaFactorySteps) 
            : factorySteps
  );
  // set asset when editing

  // Helper to determine which steps to use based on asset type
  const getStepsForAsset = useCallback((assetObj, isEditing) => {
    if (!assetObj) return factorySteps;
    
    if (isEditing) {
      if (assetObj.Type === "factory") return editFactorySteps;
      return editMegaFactorySteps;
    } else {
      if (assetObj.Type === "factory") return factorySteps;
      return megaFactorySteps;
    }
  }, []);

  useEffect(() => {
    if (editableAsset && editableAsset.id) {
      setSteps(getStepsForAsset(editableAsset, true));
    } else {
      setSteps(factorySteps);
    }
  }, [editableAsset, getStepsForAsset]);

  // Update steps when asset or isEdit changes
  useEffect(() => {
    if (asset) {
      const newSteps = getStepsForAsset(asset, !!editableAsset);
      setSteps(newSteps);
    }
  }, [asset, editableAsset, getStepsForAsset]);

  const dataSource = asset?.dataSource || "";
  const hasDataTags = (asset?.dataTags?.length || 0) > 0;
  const hasAgents = (asset?.agents?.length || 0) > 0;
  const needsMqtt = !!asset && dataSource === "live" && (hasDataTags || hasAgents);
  const hasMqttConfig = !!asset?.mqttConfig?.broker;
  const saveDisabled = !!(needsMqtt && !hasMqttConfig);

  const resetAsset = () => {
    if (!asset) {
      setAsset(defaultAsset);
      return;
    } else {
      const selectedAsset = combinedAssets.find((a) => a.id === asset.id);
      if (selectedAsset) setAsset(selectedAsset);
    }
    setActiveStep(0);
  };

  useEffect(() => {
    if (editableAsset && editableAsset.id) {
      setAsset(editableAsset);
    }
  }, [editableAsset]);
  //     if (!asset) {
  //       setAsset(null);
  //       return null;
  //     }

  //     if (!("Children" in asset) && !("suites" in asset)) return;

  //     if (asset.Type === "factory") {
  //       const newChildren = asset.Children.map((child) => {
  //         const assetObject =
  //           typeof child === "string"
  //             ? combinedAssets.find((title) => title.id === child)
  //             : combinedAssets.find((title) => title.id === child.id);

  //         if (typeof child === "string") {
  //           return {
  //             id: child,
  //             Title: assetObject ? assetObject.Title : "",
  //             Top: assetObject?.Top || "50%",
  //             Left: assetObject?.Left || "50%",
  //           };
  //         } else if (
  //           typeof child === "object" &&
  //           !child.hasOwnProperty("Title")
  //         ) {
  //           return {
  //             ...child,
  //             Title: assetObject ? assetObject.Title : "",
  //           };
  //         }

  //         return child;
  //       });

  //       const updatedData = {
  //         ...asset,
  //         Children: newChildren,
  //       };

  //       setAsset(updatedData);
  //     } else if (asset.Type === "megafactory") {
  //       setAsset(asset);
  //     }
  //   };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          flexDirection: "column",
          alignItems: "center",
          gap: 4,
        }}
      >
        <Navbar />
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            flexDirection: "column",
            alignItems: "center",
            gap: 4,
          }}
          className="px-3 md-px-0 w-full md:w-[80%] step-overflow"
        >
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h5" sx={{ alignSelf: "start" }}>
              {editableAsset ? "Edit vTEC Factory" : "Create vTEC Factory"}
            </Typography>

            <Gobutton
              text={"Back to List"}
              endIcon={<ArrowForwardIcon />}
              url={{ type: "assets", url: "/factories" }}
            />
          </Grid>
          <FactoryStepper
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            asset={asset}
            resetAsset={resetAsset}
            steps={steps}
            disabled={saveDisabled}
          >
            <Paper
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                flexDirection: "column",
                padding: 4,
                gap: 2,
              }}
              elevation={4}
              className="md:m-2"
            >
              {editableAsset ? (
                // Edit Mode
                <>
                  {activeStep === 0 && asset && (
                    <FactoryTwo asset={asset} setAsset={setAsset} />
                  )}
                  {activeStep === 1 && (
                    <FactoryFeatures asset={asset} setAsset={setAsset} />
                  )}
                  {activeStep === 2 &&
                    (asset.Type === "factory" ? (
                      <FactoryThree asset={asset} setAsset={setAsset} />
                    ) : (
                      <FactoryExample asset={asset} setAsset={setAsset} />
                    ))}
                  {activeStep === 3 &&
                    (asset.Type === "factory" ? (
                      <FactoryFour asset={asset} setAsset={setAsset} />
                    ) : (
                      <FactoryPreview asset={asset} />
                    ))}
                  {activeStep === 4 && <FactoryPreview asset={asset} />}
                </>
              ) : (
                // Create Mode
                <>
                  {activeStep === 0 && (
                    <FactoryOne asset={asset} setAsset={setAsset} />
                  )}
                  {activeStep === 1 && (
                    <FactoryTwo asset={asset} setAsset={setAsset} />
                  )}
                  {activeStep === 2 && (
                    <FactoryFeatures asset={asset} setAsset={setAsset} />
                  )}
                  {activeStep === 3 &&
                    (asset?.Type === "factory" ? (
                      <FactoryThree asset={asset} setAsset={setAsset} />
                    ) : (
                      <FactoryExample asset={asset} setAsset={setAsset} />
                    ))}
                  {activeStep === 4 &&
                    (asset?.Type === "factory" ? (
                      <FactoryFour asset={asset} setAsset={setAsset} />
                    ) : (
                      <FactoryPreview asset={asset} />
                    ))}
                  {activeStep === 5 && <FactoryPreview asset={asset} />}
                </>
              )}
            </Paper>
          </FactoryStepper>
        </Box>
      </Box>
    </>
  );
}
